// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hooks from "../../utils/Hooks.bs.jsx";
import * as React from "react";
import * as DomUtils from "../../utils/DomUtils.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as Reactfire from "reactfire";
import * as AppStorage from "../../utils/AppStorage.bs.jsx";
import * as Stdlib_Null from "@rescript/runtime/lib/es6/Stdlib_Null.js";
import * as Auth from "firebase/auth";
import * as BiometricAuthn from "./BiometricAuthn.bs.jsx";
import * as FirebaseWebAuthn from "../../backend/FirebaseWebAuthn.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as OnboardingNickName from "./OnboardingNickName.bs.jsx";
import * as Functions from "firebase/functions";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as OnboardingThrustDevice from "./OnboardingThrustDevice.bs.jsx";
import * as Browser from "@firebase-web-authn/browser";

function Onboarding(props) {
  let user = props.user;
  let app = Reactfire.useFirebaseApp();
  let auth = Reactfire.useAuth();
  let supportsWebAuthn = DomUtils.useSuportsPlatformWebauthn();
  let match = AppStorage.useLocalStorage(AppStorage.keyWebAuthn);
  let setWebAuthn = match[1];
  let webAuthn = match[0];
  let match$1 = AppStorage.useLocalStorage(AppStorage.keyThrustDevice);
  let setThrustDevice = match$1[1];
  let thrustDevice = match$1[0];
  let view = React.useMemo(() => {
    if (thrustDevice === undefined) {
      return "ThrustDevice";
    } else if (thrustDevice === "1" && supportsWebAuthn && webAuthn === undefined) {
      return "BiometricAuthn";
    } else if (Stdlib_Null.mapOr(user.displayName, "", prim => prim.trim()) === "") {
      return "NickName";
    } else {
      return;
    }
  }, [
    supportsWebAuthn,
    thrustDevice,
    user.displayName,
    webAuthn
  ]);
  let match$2 = Hooks.usePromise(async () => {
    let email = Stdlib_Null.getOrThrow(user.email);
    try {
      let functions = Functions.getFunctions(app, "europe-central2");
      await Browser.linkWithPasskey(auth, functions, email);
      return setWebAuthn("1");
    } catch (raw_error) {
      let error = Primitive_exceptions.internalToException(raw_error);
      let exn = FirebaseWebAuthn.toFirebaseWebAuthnError(error);
      if (exn.RE_EXN_ID === FirebaseWebAuthn.CancelledByUser) {
        return;
      }
      if (exn.RE_EXN_ID === FirebaseWebAuthn.NoOperationNeeded) {
        return setWebAuthn("1");
      }
      if (exn.RE_EXN_ID === "JsExn") {
        LogUtils.captureException(exn._1);
        throw error;
      }
      throw error;
    }
  });
  if (view === undefined) {
    return props.children;
  }
  let setupWebAuthn = match$2[0];
  switch (view) {
    case "NickName" :
      return <OnboardingNickName.make
        initialName={Stdlib_Null.getOr(user.displayName, "")}
        onSubmit={async values => {
          await Auth.updateProfile(user, {
            displayName: values.name
          });
          await user.reload();
        }}
      />;
    case "ThrustDevice" :
      return <OnboardingThrustDevice.make
        onSkip={() => setThrustDevice("0")}
        onThrust={() => setThrustDevice("1")}
        mentionWebAuthn={supportsWebAuthn}
      />;
    case "BiometricAuthn" :
      return <BiometricAuthn.make
        loadingOverlay={setupWebAuthn.state === "pending"}
        onSetupAuthn={match$2[1]}
        onSkip={() => setWebAuthn("0")}
        setupError={setupWebAuthn.error}
      />;
  }
}

let make = Onboarding;

export {
  make,
}
/* Hooks Not a pure module */
